import { useStaticQuery, graphql } from "gatsby";
import { PollenFooterO } from "../Types/PollenFooterO.type";

export const FooterPollen = (): PollenFooterO => {
  const {
    wp: {
      pollenOptionsSettings: { pollenFooterO },
    },
  } = useStaticQuery(graphql`
    query PolleFooter {
      wp {
        pollenOptionsSettings {
          pageSlug
          pollenFooterO {
            polllenFooterHeadline
            polllenFooterSubcopy
            pollenFooterCtaCopy
            pollenFooterCtaText
            pollenFooterCtaLink
            pollenFooterRightTitle
            pollenFooterCtaAriaText
            polllenFooterRightCtaText
          }
        }
      }
    }
  `);

  return pollenFooterO;
};
